"use client";
import { jsxs as l, jsx as r } from "react/jsx-runtime";
const h = ({
  title: o,
  titleId: i,
  desc: e,
  descId: n,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": n,
    ...t,
    children: [
      o ? /* @__PURE__ */ r("title", { id: i, children: o }) : null,
      e === void 0 ? /* @__PURE__ */ r("desc", { id: n, children: `
    Sun Fog Streamline Icon: https://streamlinehq.com
  ` }) : e ? /* @__PURE__ */ r("desc", { id: n, children: e }) : null,
      /* @__PURE__ */ r(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4.7651 14.3372h5.4698M2.714 12.286h9.572M.6628 10.2349h13.6744"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          stroke: "currentColor",
          d: "M7.5 3.3977c-2.2656 0-4.1023 1.8367-4.1023 4.1023a4.087 4.087 0 0 0 1.0256 2.7135h6.1534A4.087 4.087 0 0 0 11.6024 7.5c0-2.2656-1.8367-4.1023-4.1023-4.1023Z"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M7.5.6628v.6837M14.3372 7.5h-.6837M1.3465 7.5H.6628M12.3344 2.6656l-.2685.2685M2.934 2.934l-.2686-.2686"
        }
      )
    ]
  }
);
export {
  h as default
};
